import { Box, Flex } from '@chakra-ui/react'
import {
  faArrowDownToLine,
  faFilePdf,
} from '@fortawesome/pro-regular-svg-icons'
import { DocumentItem } from 'types/graphql'

import documentPlaceholder from 'src/assets/image/placeholder-pdf.jpg'
import {
  ItListItemAnalyticsProps,
  useAnalytics,
} from 'src/lib/hooks/analytics/useAnalytics'
import { openLinkInNewTab } from 'src/lib/utils'
import { BrandColor } from 'src/types'

import CardWrapper from '../../CardWrapper/CardWrapper'
import Exclusivity from '../../Exclusivity/Exclusivity'
import Thumbnail from '../../Thumbnail/Thumbnail'
import Title from '../../Title/Title'
import VoiceTip from '../../VoiceTip/VoiceTip'

export type DocumentCardProps = {
  profilePictureUrl: string
  brandColor: BrandColor
  title?: string
  voiceTipUrl: string
  hasVoiceTip: boolean
  trackingData: ItListItemAnalyticsProps
  documentItem: DocumentItem
  itemId: number
}

const DOCUMENT_ITEM_HEIGHT = '132px'

const DocumentCard = ({
  brandColor,
  profilePictureUrl,
  title,
  voiceTipUrl,
  hasVoiceTip,
  documentItem,
  trackingData,
  itemId,
}: DocumentCardProps) => {
  const { track } = useAnalytics()

  const onClick = (ev: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    ev.stopPropagation()
    ev.preventDefault()
    track({ eventName: 'ItList PDF Item Clicked', props: trackingData })
    if (documentItem.documentUrl) openLinkInNewTab(documentItem.documentUrl)
  }
  return (
    <CardWrapper
      itemId={itemId}
      brandColor={brandColor}
      offScreenRender={<Box w="100%" bg="dust" h={DOCUMENT_ITEM_HEIGHT} />}
    >
      <Flex
        gap={4}
        justifyContent="space-between"
        alignItems="center"
        p={4}
        onClick={onClick}
        cursor="pointer"
      >
        <Flex gap={2} direction="column" alignItems="flex-start">
          <Exclusivity
            brandColor={brandColor}
            isExclusive={documentItem.onlyAvailableOnItList}
          />
          <Title title={title} defaultTitle="Untitled PDF..." />
          <VoiceTip
            mediaUrl={voiceTipUrl}
            hasVoiceTip={hasVoiceTip}
            title={title}
            pictureUrl={profilePictureUrl}
            brandColor={brandColor}
            trackingData={trackingData}
          />
        </Flex>
        <Thumbnail
          type="document"
          brandColor={brandColor}
          coverUrl={documentItem.coverUrl || documentPlaceholder}
          fallbackIcon={documentItem.coverUrl ? faFilePdf : faArrowDownToLine}
        />
      </Flex>
    </CardWrapper>
  )
}

export default DocumentCard
